import { __ } from "../locales/translation";
export default function BadgeTag({ marketTag = false, type = "default", theme = "dark" }) {
    return (
        <>
            {marketTag && type === "open-market" && (
                <div className={`badge-tag --open-market ${theme === "dark" ? "--theme-dark" : "--theme-light"}`}>
                    <img src={`${window._env_.STATIC_HOST}/static/website/images/icons/icon-cot-check-circle-${theme}.svg`} alt="" />
                    <span className="tag">{__("MERCADO ABIERTO")}</span>
                </div>
            )}

            {marketTag && type === "close-market" && (
                <div className={`badge-tag --close-market ${theme === "dark" ? "--theme-dark" : "--theme-light"}`}>
                    <img src={`${window._env_.STATIC_HOST}/static/website/images/icons/icon-cot-close-circle-${theme}.svg`} alt="" />
                    <span className="tag">{__("MERCADO CERRADO")}</span>
                </div>
            )}

            {type === "highlighed" && (
                <div className="badge-tag --highlighted">
                    <img src={`${window._env_.STATIC_HOST}/static/website/images/icons/icon-star.svg`} alt="" />
                    <span className="tag">{__("DESTACADO")}</span>
                </div>
            )}

            {type === "refresh" && (
                <div className="badge-tag --highlighted">
                    <span className="tag">{__("ACTUALIZACIÓN C/ 20 MIN")}</span>
                </div>
            )}
        </>
    );
}
